var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-flex tw-items-center tw-cursor-pointer"},[_c('img',{staticClass:"tw-mr-1.5",class:_vm.isPhone ? 'tw-h-6' : 'tw-h-8',attrs:{"src":require('@/assets/logo_Logo.png'),"alt":"Turtlemeet Log"}}),_c('span',{staticClass:"tw-text-xl tw-font-medium",class:{ 'tw-text-lg': _vm.isPhone }},[_vm._v("Turtlemeet")])])
}
var staticRenderFns = []

export { render, staticRenderFns }